module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1245-retro-min.06b2bb38.jpg";